// app/javascript/landing/sections/AdoptionBanner.tsx
import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export function AdoptionBanner() {
  const ref = useRef<HTMLDivElement | null>(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  // Parallax suave (menos amplitud para que no se "salga")
  const y = useTransform(scrollYProgress, [0, 1], ["-200px", "200px"]);

  return (
    <section ref={ref} className="relative w-full bg-white overflow-hidden">
      {/* Imagen full width con parallax, más alta que la sección */}
      <motion.div
        style={{
          y,
          backgroundImage: "url(/landing/home/adopcion-banner.png)",
        }}
        className="
          absolute -inset-y-40 md:-inset-y-60 inset-x-0    /* se extiende 10 unidades hacia arriba y abajo */
          w-full
          bg-cover bg-center
          will-change-transform
        "
      />
      <div
        className="absolute inset-y-0 right-0 w-1/3 2xl:w-2/5 bg-purple-3/50"
        style={{ transition: "all 180ms ease-out" }}
      ></div>

      {/* Contenido centrado dentro de max-w, con altura mínima cómoda */}
      <div className="relative z-10">
        <div className="w-full max-w-5xl mx-auto px-4">
          <div className="min-h-[220px] md:min-h-[300px] lg:min-h-[320px] flex items-center py-12 md:py-16">
            <p className="md:font-light text-center text-lg md:text-2xl lg:text-3xl text-white leading-relaxed">
              En Sinestesia facilitamos la{" "}
              <span className="font-semibold">Adopción tecnológica</span> para
              ventas, comunicación y capacitación, reduciendo tiempos, errores y
              costos.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
